import React from 'react';

/**
 * Section Divider / Spacer Block Renderer
 * Variants: line, wave, spacer, dots
 */
export default function DividerRenderer({ props, variant }) {
  const {
    height = '40px',
    color = '#d6d3d1',
    style_variant = 'solid',
  } = props;

  if (variant === 'line') {
    return (
      <div
        className="flex items-center justify-center px-6"
        style={{ height }}
      >
        <hr
          className="w-full max-w-4xl"
          style={{
            border: 'none',
            borderTop: `2px ${style_variant} ${color}`,
          }}
        />
      </div>
    );
  }

  if (variant === 'wave') {
    return (
      <div className="w-full overflow-hidden" style={{ height }}>
        <svg
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
          className="w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,60 C240,120 480,0 720,60 C960,120 1200,0 1440,60 L1440,120 L0,120 Z"
            fill={color}
          />
        </svg>
      </div>
    );
  }

  if (variant === 'spacer') {
    return <div style={{ height }} />;
  }

  // Dots variant
  if (variant === 'dots') {
    return (
      <div
        className="flex items-center justify-center gap-3 px-6"
        style={{ height }}
      >
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: color }}
          />
        ))}
      </div>
    );
  }

  // Fallback to line
  return (
    <div
      className="flex items-center justify-center px-6"
      style={{ height }}
    >
      <hr
        className="w-full max-w-4xl"
        style={{ border: 'none', borderTop: `2px solid ${color}` }}
      />
    </div>
  );
}
